import { render, staticRenderFns } from "./DownloadMenu.vue?vue&type=template&id=2ef88a53&scoped=true&"
import script from "./DownloadMenu.vue?vue&type=script&lang=js&"
export * from "./DownloadMenu.vue?vue&type=script&lang=js&"
import style0 from "./DownloadMenu.vue?vue&type=style&index=0&id=2ef88a53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef88a53",
  null
  
)

export default component.exports